if (!customElements.get('predictive-search')) {
  class PredictiveSearch extends HTMLElement {
    constructor() {
      super();

      this.input = this.querySelector('input[type="search"]');
      this.resultsContainer = this.querySelector('.js-results-container');
      this.btnSubmit = this.querySelector('.js-btn-submit');
      this.btnClearText = this.querySelector('.js-btn-clear-text');
      this.errorMessageContainer = this.querySelector('.js-message-error');
      this.errorMessageText = this.errorMessageContainer
        ? this.errorMessageContainer.querySelector('[data-text]')
        : null;

      this.timeout = null;
      this.isOpen = false;
      this.drawer = this.closest('.js-drawer');

      if (!this.input) return;

      this.input.addEventListener('input', () => {
        clearTimeout(this.timeout);

        this.timeout = setTimeout(() => {
          const searchTerm = this.input.value.trim();

          if (searchTerm.length <= 0) {
            this.close();
            return;
          }

          this.isOpen = true;
          this.getSearchResults(searchTerm);
        }, 300);
      });

      this.input.addEventListener('keydown', e => {
        if (e.key !== 'Escape') return;

        if (!this.input.value) {
          if (this.drawer) {
            this.drawer.parentElement.parentElement.toggleDrawer();
          }
          return;
        }

        this.close();
      });

      if (this.btnClearText) {
        this.btnClearText.addEventListener('click', () => {
          this.close();
        });
      }
    }

    showError(userMessage = '') {
      if (!this.errorMessageContainer || !this.errorMessageText) return;

      const fallback = this.errorMessageText.dataset.defaultText || '';
      this.errorMessageText.textContent = userMessage || fallback;

      this.errorMessageContainer.classList.remove('hidden');
      if (this.resultsContainer) this.resultsContainer.classList.add('hidden');
      this.classList.remove('is-open');
    }

    clearError() {
      if (!this.errorMessageContainer || !this.errorMessageText) return;
      this.errorMessageText.textContent = '';
      this.errorMessageContainer.classList.add('hidden');
    }

    async getSearchResults(searchTerm) {
      try {
        this.clearError();

        const response = await fetch(
          `${Shopify.routes.root}search/suggest?q=${encodeURIComponent(
            searchTerm
          )}&resources[type]=product,page,article,collection,query&resources[limit]=8&section_id=predictive-search`,
          { headers: { Accept: 'text/html' } }
        );

        if (!this.isOpen) return;

        if (!response.ok) {
          // Keep technical detail for debugging, but don't show status codes to users.
          console.error('Predictive search request failed:', response.status, response.statusText);
          throw new Error('predictive_search_http_error');
        }

        const text = await response.text();
        const doc = new DOMParser().parseFromString(text, 'text/html');
        const section = doc.querySelector('#shopify-section-predictive-search');

        if (!section) {
          console.error('Predictive search markup missing #shopify-section-predictive-search');
          throw new Error('predictive_search_markup_missing');
        }

        if (this.resultsContainer) {
          this.resultsContainer.innerHTML = section.innerHTML;
        }

        this.open();
      } catch (error) {
        // Show localized fallback (from data-default-text). Never show raw error codes/messages.
        this.showError('');
        console.error('Predictive search error:', error);
      }
    }

    open() {
      this.classList.add('is-open');

      if (this.resultsContainer) {
        this.resultsContainer.classList.remove('hidden');
      }

      if (this.errorMessageContainer) {
        this.errorMessageContainer.classList.add('hidden');
      }

      if (this.btnSubmit) {
        this.btnSubmit.setAttribute('tabindex', '-1');
      }

      if (this.btnClearText) {
        this.btnClearText.removeAttribute('disabled');
      }
    }

    close() {
      this.isOpen = false;
      this.classList.remove('is-open');

      if (this.resultsContainer) {
        this.resultsContainer.classList.add('hidden');
      }

      if (this.errorMessageContainer) {
        this.errorMessageContainer.classList.add('hidden');
      }

      if (this.input) {
        this.input.value = '';
        this.input.focus();
      }

      if (this.btnSubmit) {
        this.btnSubmit.removeAttribute('tabindex');
      }

      if (this.btnClearText) {
        this.btnClearText.setAttribute('disabled', true);
      }
    }
  }

  customElements.define('predictive-search', PredictiveSearch);
}